<template>
    <div>
        <el-dialog v-model="downloadPaperShow" title="Tips" width="500" :show-close="false" :align-center="true"
            :close-on-click-modal="false">
            <template #header>
                <div class="header">试卷下载</div>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content pl-10 flex flexcolumn">
                <div class="content_title mb-15">是否需要答案解析</div>
                <el-radio-group v-model="downloadPapams.includeAnswer">
                    <el-radio :value="true" size="large">需要</el-radio>
                    <el-radio :value="false" size="large">无需</el-radio>
                </el-radio-group>
                <div v-if="downloadPapams.includeAnswer">
                    <div class="content_title my-15">附加位置</div>
                    <el-radio-group v-model="downloadPapams.answerPosition">
                        <el-radio value="after" size="large">题后</el-radio>
                        <el-radio value="end" size="large">卷后</el-radio>
                    </el-radio-group>
                    <div class="content_title my-15">附加内容</div>
                    <div class="flex Flexalign">
                        <el-checkbox-group v-model="checkList">
                            <el-checkbox value="includeAnalysis" label="试题分析" />
                            <el-checkbox value="includeExplanation" label="试题解析" />
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="btn cursor_pointer" @click="downloadPaperForPreview">立即下载</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as Cache from "@/assets/utils/cache";
import axios from "axios";
import * as Config from "@/config/config";
export default {
    name: "GjkcH5DownloadPaper",
    props: {
        paperInfo: {},
        examinationInfo: {}
    },

    data() {
        return {
            downloadPaperShow: false,
            downloadPapams: {
                paperId: '',
                format: 'pdf',
                includeAnswer: false,
                includeAnalysis: false,
                includeExplanation: false,
                answerPosition: 'end',
                isDownload:true, // 是否统计下载次数
            },
            currentBlob: '',
            previewUrl: null,      // 预览URL
            checkList: []
        };
    },

    mounted() { },

    methods: {
        closePopup() {
            this.downloadPaperShow = false;
        },
        // 下载试卷文件并创建预览
        async downloadPaperForPreview() {
            this.downloadPapams.paperId = this.examinationInfo.paperId;
            this.downloadPapams.includeAnalysis = (this.checkList.findIndex(item => item == 'includeAnalysis') != -1) ? true : false;
            this.downloadPapams.includeExplanation = (this.checkList.findIndex(item => item == 'includeExplanation') != -1) ? true : false;
            const token = Cache.get('token');

            // 先清理之前的预览URL
            this.revokePreviewUrl();

            try {
                const response = await axios.post(
                    Config.API_BASE_URL + '/yymCourseQuestionExamPaper/download',
                    this.downloadPapams,
                    {
                        responseType: 'blob',
                        headers: {
                            'Authorization': `${token}`,
                            'Content-Type': 'application/json',
                        },
                        timeout: 30000,
                    }
                );

                if (response.data instanceof Blob) {
                    const blob = response.data;
                    this.currentBlob = blob;

                    console.log(`文件大小: ${blob.size} 字节`);
                    console.log(`文件类型: ${blob.type}`);

                    const filename = this.generateFileName();
                    const url = window.URL.createObjectURL(this.currentBlob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    link.click();

                    // 清理URL
                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                    }, 100);

                    this.$Dialog.toast('开始下载');
                } else {
                    throw new Error('返回的数据不是Blob格式');
                }

                return response;
            } catch (error) {
                console.error('下载失败:', error);

                // 尝试解析错误信息
                if (error.response && error.response.data instanceof Blob) {
                    const errorText = await error.response.data.text();
                    try {
                        const errorJson = JSON.parse(errorText);
                        this.$Dialog.toast(errorJson.message || '加载预览失败');
                    } catch {
                        this.$Dialog.toast('加载预览失败，请检查网络或权限');
                    }
                } else {
                    this.$Dialog.toast('加载预览失败，请检查网络连接');
                }

                throw error;
            }
        },
        // 清理预览URL
        revokePreviewUrl() {
            if (this.previewUrl) {
                window.URL.revokeObjectURL(this.previewUrl);
                this.previewUrl = null;
            }
        },
        // 生成文件名
        generateFileName() {
            const baseName = this.paperInfo?.paperName || '试卷';
            const format = this.downloadPapams.format;
            const contents = [];

            if (this.downloadPapams.includeAnswer) contents.push('答案');
            if (this.downloadPapams.includeAnalysis) contents.push('解析');
            if (this.downloadPapams.includeExplanation) contents.push('分析');

            let suffix = '';
            if (contents.length > 0) {
                suffix = `_含${contents.join('')}`;
            }

            const cleanName = baseName.replace(/[<>:"/\\|?*]/g, '_');
            const fileExtension = format === 'word' ? 'docx' : format;
            return `${cleanName}${suffix}.${fileExtension}`;
        },
    },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    width: 450px;
    // height: 512px;
    background: linear-gradient(180deg, #DEFFF8 0%, #FFFFFF 29%, #FFFFFF 100%);
    border-radius: 29px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
    padding: 0 10px 0 20px;
    box-sizing: border-box;
    text-align: center;
}

.header {
    text-align: center;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    line-height: 60px;
    // border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #333333;
}

.dialog_content {
    .content_title {
        font-weight: 500;
        font-size: 16px;
        color: #303030;
    }

    .btn {
        width: 227px;
        height: 48px;
        background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
        border-radius: 30px;
        line-height: 48px;
        text-align: center;
        color: #FFFFFF;
        margin: 20px auto 10px;
    }
}
</style>